import { Language } from "../languages/labels/language.labels";

export function accountingAccountTypeList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'group', display: lang.labels.group },
    { code: 'title', display: lang.labels.title },
    { code: 'leave', display: lang.labels.leave }
  ]
}

export function accountingAccountTypeValue(lang: Language, code: string): string {
  let accountType = accountingAccountTypeList(lang).find((item) => (item.code === code))
  return accountType ? accountType.display : lang.labels.undefined
}
